import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/success.jpg'


const _withScopeId = n => (_pushScopeId("data-v-43bb24a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "You have successfully applied.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Thank you for your interest in Kuehne+Nagel.", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "success"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createTextVNode("Please click "),
        _createElementVNode("a", { href: _ctx.link }, " here ", 8, _hoisted_5),
        _createTextVNode("to go to the home page.")
      ]),
      _hoisted_6
    ])
  ]))
}